import React from "react"
import PropTypes from "prop-types"

import { MAX_RATING } from "../../Daily/static"
import { opcionesHora } from "../../Daily/useProviderOrderForm"
import { DELTA_ALERTA } from "../static"
import { dinero, piezas } from "../helpers"

const puntos = Array.from({ length: MAX_RATING }, (unused, index) => index + 1)

const Estrellas = ({ label, value }) => (
  <div className="pv2-rating">
    <span className="pv2-rating-tag">{label}</span>
    <span className="pv2-stars">
      {puntos.map(punto => (
        <span key={punto} className={value >= punto ? "is-on" : ""}>
          ★
        </span>
      ))}
    </span>
  </div>
)

Estrellas.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
}

const ComparatorRow = ({
  fila,
  fechasRecepcion,
  fechaPedido,
  esLocal,
  isSaving,
  onChangeCantidad,
  onChangeFecha,
  onChangeHora,
  onAgregar,
}) => {
  const horas = opcionesHora(fila.fecha, esLocal, fechaPedido)
  const capturada = fila.cantidad > 0
  const esHembra = /hembra/i.test(fila.producto || "")
  const puedeAgregar = capturada && !fila.excede && !!fila.hora && !isSaving

  const clases = ["pv2-grid", "pv2-row"]
  if (capturada) clases.push("is-captured")
  else if (fila.esMejor) clases.push("is-best")

  return (
    <div className={clases.join(" ")}>
      <div className="pv2-prov">
        <div className={`pv2-accent${esHembra ? " is-hembra" : ""}`} />
        <div className="pv2-prov-text">
          <div className="pv2-prov-name" title={fila.proveedor}>
            {fila.proveedor}
          </div>
          <div className="pv2-prov-farm" title={fila.granja}>
            {fila.granja}
          </div>
        </div>
      </div>

      <div>
        <span className={`pv2-prod${esHembra ? " is-hembra" : ""}`}>
          {fila.producto}
        </span>
      </div>

      <div className="pv2-right pv2-mono">
        {piezas(fila.disponible)}
        <span className="pv2-unit">pz</span>
      </div>

      <div
        className="pv2-right pv2-mono pv2-muted"
        title={`${fila.pesoMin} – ${fila.pesoMax} kg`}
      >
        {fila.pesoProm.toFixed(2)}
        <span className="pv2-unit">kg</span>
      </div>

      <div className="pv2-ratings">
        <Estrellas label="P" value={fila.pigmento} />
        <Estrellas label="C" value={fila.calidad} />
        <Estrellas label="S" value={fila.salud} />
      </div>

      <div className="pv2-right pv2-precio-cell">
        {fila.esMejor && <span className="pv2-best">MEJOR</span>}
        <span className={`pv2-mono pv2-precio${fila.esMejor ? " is-best" : ""}`}>
          ${dinero(fila.precio)}
        </span>
      </div>

      <div className="pv2-right">
        <span
          className={`pv2-mono pv2-delta${
            fila.delta <= 0.001
              ? " is-none"
              : fila.delta > DELTA_ALERTA
              ? " is-high"
              : ""
          }`}
        >
          {fila.delta <= 0.001 ? "—" : `+${dinero(fila.delta)}`}
        </span>
      </div>

      <div className="pv2-recepcion">
        <select
          className={`pv2-mini-select${fila.fechaEditada ? " is-edited" : ""}`}
          value={fila.fecha}
          onChange={event => onChangeFecha(fila.id, event.target.value)}
        >
          {fechasRecepcion.map(opcion => (
            <option key={opcion.value} value={opcion.value}>
              {opcion.label}
            </option>
          ))}
        </select>
        <select
          className="pv2-mini-select pv2-mono is-hour"
          value={fila.hora}
          onChange={event => onChangeHora(fila.id, event.target.value)}
          disabled={horas.length === 0}
        >
          {horas.length === 0 && <option value="">—</option>}
          {horas.map(opcion => (
            <option key={opcion.value} value={opcion.value}>
              {opcion.value}
            </option>
          ))}
        </select>
      </div>

      <div>
        <input
          type="number"
          min="0"
          max={fila.disponible}
          className={`pv2-qty pv2-mono${
            fila.excede ? " is-over" : capturada ? " is-on" : ""
          }`}
          value={fila.qty}
          placeholder="0"
          onChange={event => onChangeCantidad(fila.id, event.target.value)}
          onWheel={event => event.target.blur()}
        />
      </div>

      <div className="pv2-right">
        <span className={`pv2-mono pv2-importe${capturada ? " is-on" : ""}`}>
          {capturada ? `$${dinero(fila.importe)}` : "—"}
        </span>
      </div>

      <div className="pv2-add-cell">
        <button
          type="button"
          className={`pv2-add${puedeAgregar ? " is-on" : ""}`}
          title="Solicitar solo este renglón"
          disabled={!puedeAgregar}
          onClick={() => onAgregar(fila.id)}
        >
          +
        </button>
      </div>
    </div>
  )
}

ComparatorRow.propTypes = {
  fila: PropTypes.object.isRequired,
  fechasRecepcion: PropTypes.array.isRequired,
  fechaPedido: PropTypes.string,
  esLocal: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  onChangeCantidad: PropTypes.func.isRequired,
  onChangeFecha: PropTypes.func.isRequired,
  onChangeHora: PropTypes.func.isRequired,
  onAgregar: PropTypes.func.isRequired,
}

export default ComparatorRow
